import { render, staticRenderFns } from "./CharacteristicsForm.vue?vue&type=template&id=1c98b09a&scoped=true"
import script from "./CharacteristicsForm.vue?vue&type=script&lang=js"
export * from "./CharacteristicsForm.vue?vue&type=script&lang=js"
import style0 from "./CharacteristicsForm.vue?vue&type=style&index=0&id=1c98b09a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c98b09a",
  null
  
)

export default component.exports